// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ExportDataExcelHistoryFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'exportDate': !exists(json, 'exportDate') ? undefined : new Date(json['exportDate']),
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}
export function ExportDataExcelHistoryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'exportDate': value.exportDate === undefined ? undefined : value.exportDate.toISOString(),
        'description': value.description,
    };
}
